import axios from 'axios';

const BASE_URL = process.env.REACT_APP_BASE_URL;

export interface FocusGroupWorkflowStatus {
  workflow_type: string;
  current_state: string;
  available_transitions: string[];
  workflow_metadata: Record<string, any>;
  created_on: string;
  updated_on: string;
  created_by: string;
  last_updated_by: string;
}

const getFocusGroupWorkflowStatus = async (
  eoaId: string,
  schoolId: string,
  access_token: string
): Promise<FocusGroupWorkflowStatus> => {
  const response = await axios.get<FocusGroupWorkflowStatus>(
    `${BASE_URL}/eoa/${eoaId}/workflows/focus_group_report/${schoolId}/status`,
    {
      headers: {
        Authorization: `Bearer ${access_token}`,
      },
    }
  );

  return response.data;
};

export interface FocusGroupWorkflowTransitionResponse {
  workflow_type: string;
  previous_state: string;
  current_state: string;
  transition_name: string;
  workflow_metadata: Record<string, any>;
  updated_on: string;
  last_updated_by: string;
}

const executeFocusGroupWorkflowTransition = async (
  eoaId: string,
  schoolId: string,
  access_token: string,
  transition_name: string,
  metadata?: Record<string, any>
): Promise<FocusGroupWorkflowTransitionResponse> => {
  const requestBody: any = { transition_name };
  if (metadata) {
    requestBody.workflow_metadata = metadata;
  }

  const response = await axios.post<FocusGroupWorkflowTransitionResponse>(
    `${BASE_URL}/eoa/${eoaId}/workflows/focus_group_report/${schoolId}/transitions`,
    requestBody,
    {
      headers: {
        Authorization: `Bearer ${access_token}`,
        'Content-Type': 'application/json',
      },
    }
  );

  return response.data;
};

export { getFocusGroupWorkflowStatus, executeFocusGroupWorkflowTransition };
